<template>
  <ul class="reminder-list m_t8" v-if="reminderList.length">
    <li
      v-for="(item,index) in reminderList"
      :key="item.reminderId"
      class="reminder-item"
      :class="{past:index<timeIndex || timeIndex ==-1,'c_pointer':item.scheduleType == 'interview'}"
      @click="handleClickToPage(item)"
    >
      <div v-if="isToday==1 && index==timeIndex" class="time-line top" />
      <div class="reminder-content">
        <xin-icon v-if="item.scheduleType == 'memo'" xin-type="draft-line" class="f_s14" />
        <p class="text color-label text-pre-wrap">{{item.reminderData}}</p>
      </div>
      <p v-if="item.scheduleType == 'interview'" class="time">
        {{item.time}}~{{item.endTime}} {{item.scheduleRemarks}}
      </p>
      <p v-if="item.scheduleType == 'memo'"  class="time">
        <span>
          <xin-icon v-if="item.openRemind" xin-type="alarm-fill" class="remind f_s14" />{{item.time}}
        </span>
        <span>
          <xin-icon xin-type="icon_edit_standard" class="edit f_s14 m_r16 sk--hover-text" @click="$emit('edit',item)" />
          <xin-icon xin-type="icon_delete_standard" class="delete f_s14" @click="$emit('delete',item)" />
        </span>
      </p>
      <div v-if="isToday==1 && timeIndex==-1 && index==reminderList.length-1" class="time-line bottom" />
    </li>
  </ul>
</template>

<script lang="ts">
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import {HomeApi} from '@/module/home/service/home-api.service';

  interface TReminderItem {
    time:string;
    scheduleType:string;
    scheduleRemarks:string;
    reminderId:string;
    reminderData:string;
    openRemind:0|1;
    endTimeStamp:number;
    endTime:string;
    moduleBusinessId:string;
    businessId:string;
  }

  @Component({
    components:{}
  })
  export default class ReminderList extends Vue {
    @Prop({default:''})
    date!:string

    @Prop({default:0})
    isToday!:number

    timer:undefined|number = undefined
    timeIndex = -1
    loading = false
    reminderList:TReminderItem[] = []

    @Watch("date")
    dateChange(nVal:string,oVal:string){
      if(nVal && oVal){
        this.init()
      }
    }

    created(){
      this.init()
    }

    init(){
      this.loading = true
      clearInterval(this.timer)
      HomeApi.ajaxGetAttendanceCalendarReminder({date:this.date}).then((result:any) => {
        if(result){
          this.reminderList = result || []
          this.timeIndex = this.getTimeIndex()
          this.initSetinternal()

          let cont = 0
          this.reminderList.forEach((i:TReminderItem)=>{
            if(i.scheduleType == 'memo'){
              cont = cont + 1
            }
          })
          if(this.reminderList && cont >= 5){
            this.$emit('hideAddRimendBtn',false)
          }else{
            this.$emit('hideAddRimendBtn',true)
          }
          this.loading = false
        }
      });
    }

    getTimeIndex(){
      let timeIndex = -1
      const now = new Date().getTime()
      for(let i=0; i<this.reminderList.length; i++){
        const { endTimeStamp } = this.reminderList[i]
        if(now < endTimeStamp * 1000){
          timeIndex = i;
          break
        }
      }

      return timeIndex
    }

    initSetinternal(){
      if(this.isToday == 0) return
      this.timer = setInterval(()=>{
        const index = this.getTimeIndex()
        if(this.reminderList.length == 1 || index == -1){
          clearInterval(this.timer)
        }
        if(index >= 0 && index!=this.timeIndex){
          this.timeIndex = index
        }
      },2*60*100)
    }

    handleClickToPage(item:TReminderItem){
      if(item.scheduleType == 'memo') return

      this.XrxsTracker.$track('a_homeClickCalendarSchedule','','interview-resume')

      window.location.href = `/staff/recruitment/interview-detail?resumeId=${item.moduleBusinessId}&noticeId=${item.businessId}&noticeType=1`
    }
  }
</script>

<style lang="scss" scoped>
.reminder-list{
  box-sizing: border-box;
  overflow-y: auto;
  max-height: 280px;
  margin-left: -4px;
  padding-left: 8px;
  .reminder-item{
    position: relative;
    box-sizing: border-box;
    margin-bottom: 8px;
    padding: 8px 16px;
    min-height: 50px;
    background: #F4FAFF;
    font-size: 12px;
    font-weight: 400;

    &:hover{
      .time .edit,.time .delete{
        display: inline;
      }
    }
    &.past{
      background: rgba(var(--xs-border-color-table),.3);
      &::before{
        background: var(--xs-border-color-spec);
      }
    }
    .reminder-content{
      display: flex;
      .xin-icon{
        flex-shrink: 0;
        margin-top: 2px;
        margin-right: 2px;
      }
      .text{
        line-height: 18px;
      }
    }
    .time-line{
      position:absolute;
      top: -4px;
      left: -3px;
      right: 2px;
      height: 1px;
      background: #FA9B9B;
      &.bottom{
        top: auto;
        bottom: -4px;
      }
      &::before{
        content: '';
        position: absolute;
        left: -3px;
        top: -1px;
        display: inline-block;
        width: 3px;
        height: 3px;
        border-radius: 2px;
        background: #FA9B9B;
      }
    }
    .content{
      color: var(--xs-text-color-primary);
    }
    .time{
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 4px;
      min-height: 18px;
      .remind{
        margin-right: 2px;
        color: $sysWarningColor;
      }
      .edit,.delete{
        display: none;
        color: #979797;
        cursor: pointer;
      }
      .delete:hover{
        color: $sysErrorColor;
      }
    }
    &::before{
      content: '';
      position: absolute;
      top: 0;
      bottom: 0;
      left: -3px;
      width: 3px;
      background: #32A7FE;
    }
  }
}
</style>
